import { API_URL } from "constants/index";
import { fetchWithAuth } from "shared/api/fetch-with-auth";
import { FileLabel } from "shared/types/file";
import { BuildingDTO } from "shared/types/building";

/**
 * Calculates dot values for taxation information based on the presence of taxation reports
 * @param building The building to calculate taxation dot values for
 * @param session The current session for authentication
 * @returns Object with dot values for red, orange, green, and transparent categories
 */
export const calculateTaxationDotValues = async (building: BuildingDTO, session: any) => {
    let dotValues: any = {
        red: { count: 0, labels: [] },
        orange: { count: 0, labels: [] },
        green: { count: 0, labels: [] },
        transparent: { count: 0, labels: [] },
    };

    try {
        // Fetch taxation file logs for the building
        const queryParams = new URLSearchParams();
        if (building?.id) {
            queryParams.append('buildingId', building.id);
        }

        const labels = [
            FileLabel.SchattingTaxatieverslag,
            FileLabel.TaxatieBerekeningen,
        ];
        queryParams.append('labels', labels.join(','));

        const response = await fetchWithAuth(
            `${API_URL}/file/get-file-logs?${queryParams.toString()}`,
            { method: 'GET' },
            session
        );
        const fileLogs = await response.json();
        
        // Check if any taxation reports exist
        const taxationReports = fileLogs.filter((log: any) =>
            log.label.includes(FileLabel.SchattingTaxatieverslag) || 
            log.label.includes(FileLabel.TaxatieBerekeningen)
        );

        if (taxationReports.length > 0) {
            // Taxation reports are present
            dotValues.green.count++;
            dotValues.green.labels.push("Taxatieverslag aanwezig");
        } else {
            // No taxation reports found
            dotValues.transparent.count++;
            dotValues.transparent.labels.push("Geen taxatieverslag aanwezig");
        }
    } catch (error) {
        console.error('Error fetching taxation report logs:', error);
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Fout bij ophalen taxatieverslagen");
    }

    return dotValues;
};
